/** Easing curves. Every curve satisfies f(0) === 0 and f(1) === 1. */

import { TAU } from './math.ts';

export type EaseFn = (t: number) => number;

export const ease = {
  linear: (t) => t,
  outCubic: (t) => 1 - (1 - t) ** 3,
  inCubic: (t) => t * t * t,
  inOutCubic: (t) => (t < 0.5 ? 4 * t * t * t : 1 - (-2 * t + 2) ** 3 / 2),
  outQuint: (t) => 1 - (1 - t) ** 5,
  inOutQuint: (t) => (t < 0.5 ? 16 * t ** 5 : 1 - (-2 * t + 2) ** 5 / 2),
  /** Overshoot curve. c3 must equal c1 + 1, otherwise f(0) is not 0. */
  outBack: (t) => {
    const c1 = 1.2;
    const c3 = c1 + 1;
    return 1 + c3 * (t - 1) ** 3 + c1 * (t - 1) ** 2;
  },
  outElastic: (t) =>
    t === 0 || t === 1 ? t : 2 ** (-9 * t) * Math.sin((t * 10 - 0.75) * (TAU / 3)) + 1,
  outBounceSoft: (t) => 1 - (1 - t) ** 2.6 * Math.cos(t * Math.PI * 1.6),
} satisfies Record<string, EaseFn>;

export type EaseName = keyof typeof ease;
